<template>
  <a-form-item
    :label="data.fieldname"
    class="sensitive"
  >
    <span class="fs-warning">{{ $t('message["345"]') }}</span>
  </a-form-item>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  }
}
</script>

<style lang="scss" scoped>
.sensitive {
}
</style>
